import { AccordionBody, AccordionButton, AccordionHeader, AccordionItem, Card } from "react-bootstrap";
import { AddressTypeBadgeList } from "_components/Addresses/AddressTypeBadgeList";
import ContactPersonListDetails from "./ContactPersonsDetails";
import { ContainerListDetails } from "./ContainerListDetails";
import { ContractorWastesCard } from "./ContractorWastesCard";
import { dateToString } from "../../../../domain/Configuration";
import { AllowedCodesBdoModal } from "./AllowedCodesBdoModal";
import { ContractorWasteKindDetails } from "./ContractorWasteKindDetails";
import { ContractorServicesCard } from "./ContractorServicesCard";
import { CONTRACTOR_TYPES } from "../../../../domain/ContractorType";

const AddressDetails = ({ contractorId, contractorTypes, address }) => {
  const { bdoDetails, rawAddress, remarks, wasteProcessingDecisionData } = address;
  const isSender = contractorTypes.includes(CONTRACTOR_TYPES.SENDER);
  const isReceiver = contractorTypes.includes(CONTRACTOR_TYPES.RECEIVER);

  return (
    <AccordionItem  eventKey={address.id}>
      <AccordionHeader>
        <Card.Title as="h6" className="mx-2">
        {address.name?.toUpperCase()}
        </Card.Title> <AddressTypeBadgeList address={address}/>
      </AccordionHeader>
      <AccordionBody>
            {/*<AddressTypeBadgeList address={address}/>*/}
            {/*<Card.Title>{address.name}</Card.Title>*/}
            <Card.Subtitle className="mb-2 text-muted">{rawAddress}</Card.Subtitle>
            {bdoDetails?.registrationNumber && <Card.Text><b>EUP: {bdoDetails?.registrationNumber}</b></Card.Text>}
            {wasteProcessingDecisionData && <Card.Text>
              Decyzja: {wasteProcessingDecisionData?.decisionNumber} ({dateToString(wasteProcessingDecisionData?.decisionDate)})
              {" "}<AllowedCodesBdoModal
              allowedWasteCodesBdo={wasteProcessingDecisionData?.allowedWasteCodesBdo}
              allowedWasteCodesBdoCount={wasteProcessingDecisionData?.allowedWasteCodesBdoCount}/>
            </Card.Text>}
            <Card.Subtitle>{remarks}</Card.Subtitle>
            <ContactPersonListDetails contactPersons={address.contactPersons} useLightBorder/>
            {isSender && <ContractorServicesCard services={address.purchaseServices} servicesSuffix="zakupowe" />}
            {isReceiver && <ContractorServicesCard services={address.saleServices} servicesSuffix="sprzedażowe" />}
            <ContractorWastesCard title="Towary do załadunku" contractorTypes={contractorTypes} wastes={address.loadingWastes}/>
            <ContainerListDetails containers={address.usedContainers}/>
            <ContractorWastesCard title="Towary do sprzedaży" contractorTypes={contractorTypes} wastes={address.saleWastes}/>
            <ContractorWasteKindDetails contractorId={contractorId} address={address}/>
      </AccordionBody>
    </AccordionItem>
  );
};

export default AddressDetails;

